<template>

	<div id="content" class="content main">
		<!-- 메인 슬라이드 -->
		<div class="main-visual m-b-20">
			<div class="swiper-container">
				<ul class="swiper-wrapper">

					<li class="swiper-slide" v-for="(item, index) in mainBanners">
						<a :href="item.link" class="link-item" :target="item.linkType">
							<div class="thumb-box" :style="'background-image: url(' + item.bannerSrc + ');'"></div>
							<div class="text-box">
<!--								<div class="cate bedge-fill">
									<span class="prim">건축</span>
									<span class="sec">엔지니어링</span>
								</div>-->
								<h3 class="tit text-center" v-html="item.title"></h3>
							</div>
						</a>
					</li>

				</ul>
				<div class="btn-next"></div>
				<div class="btn-prev"></div>
			</div>
		</div>



		<div class="m-b-20" v-for="(item, index) in subBanners">
			<template v-if="item.link != ''">
				<a :href="item.link" :target="item.linkType"><img :src="item.bannerSrc" style="width: 100%;" :alt="item.title" /></a>
			</template>
			<template v-else>
				<img :src="item.bannerSrc" :target="item.linkType" style="width: 100%;" :alt="item.title" />
			</template>
		</div>


		<!-- 새로 추가된 동영상 -->
		<div class="main-update container" v-if="eduMainList.length > 0">
			<div class="main-title">
				<h2 class="tit">새로 추가된 강좌</h2>
				<router-link to="/e-learning-services/200101/architecture" class="btn-more">더보기</router-link>
			</div>
			<div class="swiper-container">
				<ul class="main-list swiper-wrapper">


					<li class="swiper-slide" v-for="(item, index) in eduMainList">
						<a href="javascript:;" class="link-item" @click="goLearning(item.emIdx)">
							<div class="thumb-box" v-if="item.thumbnail != null && item.thumbnail !== ''" :style="'background-image: url(' + item.thumbnail + ');'"></div>
							<div class="thumb-box" v-else style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);"></div>
							<div class="text-box">
								<div class="cate bedge-line">
									<span class="prim" v-if="item.cateCode != null">{{ item.cateCodeVO.codeName }}</span>
									<span class="sec" v-if="item.isMajor">주요교육</span>
								</div>
								<h3 class="tit">
									{{ item.shortTitle }} {{ item.eduTitle }}</h3>
								<p class="desc">{{ item.introduce }}</p>
								<ul class="info">
									<li class="like"><span class="blind">좋아요</span>{{ item.wishCount }}</li>
									<li class="view"><span class="blind">조회수</span>{{ item.views }}</li>
								</ul>
							</div>
						</a>
					</li>


				</ul>
			</div>
			<div class="btn-next"></div>
			<div class="btn-prev"></div>
		</div>
		<!-- 학슴중인 교육 -->
		<div class="main-ongoing container" v-if="requestEduList.length > 0">
			<div class="main-title">
				<h2 class="tit">학습중인 강좌</h2>
				<router-link to="/app/education/mine/" class="btn-more">더보기</router-link>
			</div>
			<div class="swiper-container">
				<ul class="main-list swiper-wrapper">
					<li class="swiper-slide" v-for="(item, index) in requestEduList">
						<a href="javascript:;" class="link-item" @click="goLearning(item.emIdx)">
							<div class="thumb-box" :style="'background-image: url(' + item.thumbnail + ');'"></div>
							<div class="text-box">
								<div class="cate bedge-line">
									<span class="prim" v-if="item.cateCode != null">{{ item.cateCodeVO.codeName }}</span>
									<span class="sec" v-if="item.isMajor">주요교육</span>
								</div>
								<h3 class="tit">{{ item.shortTitle }} {{ item.eduTitle }}
								</h3>
								<p class="desc">{{ item.introduce }}</p>
								<ul class="info">
									<li class="like"><span class="blind">좋아요</span>{{ item.wishCount }}</li>
									<li class="view"><span class="blind">조회수</span>{{ item.views }}</li>
								</ul>
							</div>
						</a>
					</li>

				</ul>
			</div>
			<div class="btn-next"></div>
			<div class="btn-prev"></div>
		</div>
		<!-- 최근 게시물 -->
		<div class="main-latest container" v-if="boardList.length > 0">
			<div class="main-title">
				<h2 class="tit">최근 게시물</h2>
<!--				<a href="javascript:;" class="btn-more">더보기</a>-->
			</div>
			<ul class="main-list row row-cols-1 row-cols-lg-2 row-cols-xl-2">

				<li class="col" v-for="(item, index) in boardList">
					<a href="javascript:;" class="link-item" @click="goBoardView( item.boardKey, item.idx)">
						<div class="thumb-box" v-if="item.thumbFile !== null" :style="'background-image:url(' + APIs.BOARD_FILES_SHOW + item.thumbIdx + ');'" ></div>
						<div class="thumb-box" v-else style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);" ></div>
						<div class="text-box">
							<div class="cate bedge-line">
								<span class="prim">{{ item.cateName }}</span>
								<span class="sec" v-if="item.isNotice">공지</span>
							</div>
							<h3 class="tit">{{ item.title }}</h3>
							<p class="desc">{{ item.contentText }}</p>
							<ul class="info">
								<li class="like"><span class="blind">좋아요</span>{{ item.likeCount }}</li>
								<li class="view"><span class="blind">조회수</span>{{ item.views }}</li>
							</ul>
						</div>
					</a>
					<router-link :to="'/app/board/' + item.boardKey + '/'" class="btn-list-more">더보기</router-link>
				</li>

			</ul>
		</div>

	</div>

</template>

<script>
import $ from "jquery";
import Swiper from "../../public/ssflex/assets/js/swiper.min";

export default {
	name: "index",
	data () {

		return {
			coAccountVO: {},
			rateCode: 0,

			mainBanners: [],
			subBanners: [],
			eduMainList: [],

			popupList: [],

			requestEduList: [],

			boardList: [],
		}
	},
	created() {
		this.getAccountRateCode()
		this.getRequestEduList();
		this.getMainData();
		this.recentBoardList();
		this.getUsePopupList();

		window.addEventListener('resize', this.handleResize);
	},
	mounted() {
	},
	watch: {

	},
	updated() {
		/*this.$nextTick(() => {
			import('@/../public/assets/js/common-ui')
			this.handleResize();
		})*/
	},
	methods: {
		getAccountRateCode() {
			this.coAccountVO = this.getSessionProc();

		},
		handleResize() {
			// $('.main-ongoing').find('.swiper-slide').css('width', `${$('.main-update').find('.swiper-slide').css('width')}`)
			// $('.main-ongoing').find('.swiper-slide').css('margin-right', `${$('.main-update').find('.swiper-slide').css('margin-right')}`)
			$('.main-latest').find('.desc').css('-webkit-line-clamp', `${(Math.ceil($('.main-latest').find('.thumb-box').eq(0).css('height').replace(/[^0-9, .]/g, "")) > 214 ? 4 : 3)}`)
		},
		getMainData () {

			//this.mainBanners = []
			this.eduMainList = []

			const self = this
			self.axiosCaller.get( self, self.APIs.DISPLAY + "/main/", {}, (res) => {

				const result = res.data
				console.log("getMainData")
				console.log(result)
				if ( result.status === "ok" ) {

					// main1 코드 배너만 목록 정의
					const tmpList = result.bannerList
					tmpList.forEach(tmp => {
						if ( tmp.bannerOpt === "main1" && tmp.isDisplay === true ) {
							self.mainBanners.push( tmp )
						}
						if ( tmp.bannerOpt === "main2" && tmp.isDisplay === true ) {
							self.subBanners.push( tmp )
						}
					})

					// 교육 목록 정의
					self.eduMainList = result.eduList;
					// console.log(self.eduMainList)

					self.$nextTick(() => {

						$(".main-visual .swiper-container").each(function () {
							new Swiper($(this), {
								slidesPerView: 3,
								loop: true,
								navigation: {
									nextEl: ".main-visual .btn-next",
									prevEl: ".main-visual .btn-prev",
								},
								breakpoints: {
									1279: {
										slidesPerView: 2,
									},
									991: {
										slidesPerView: 2,
									},
									767: {
										slidesPerView: 2,
									},
									575: {
										slidesPerView: 1,
									},
								},
							});
						});

						$(".main-update .swiper-container").each(function () {
							new Swiper($(this), {
								slidesPerView: 3,
								spaceBetween: 24,
								navigation: {
									nextEl: ".main-update .btn-next",
									prevEl: ".main-update .btn-prev",
								},
								breakpoints: {
									991: {
										slidesPerView: 3,
										spaceBetween: 24,
									},
									767: {
										slidesPerView: 2.3,
										spaceBetween: 16,
									},
									575: {
										slidesPerView: 1.3,
										spaceBetween: 16,
									},
								},
							});
						});
					})

				} else {
					console.log( result.msg )
				}

			})

		},


		getRequestEduList () {

			if ( !this.isLogin() ) {
				return;
			}

			this.requestEduList = []

			const self = this
			self.axiosCaller.get( self, self.APIs.DISPLAY + "/main/requestEduList", {
				page: 0,
				size: 10,
				sort: 'createDate,DESC',
				rateCode: this.rateCode,
			}, (res) => {

				const result = res.data

				if ( result.status === "ok" ) {

					self.requestEduList = result.list
					self.$nextTick(() => {
						$(".main-ongoing .swiper-container").each(function () {
							new Swiper($(this), {
								slidesPerView: 4,
								spaceBetween: 24,
								navigation: {
									nextEl: ".main-ongoing .btn-next",
									prevEl: ".main-ongoing .btn-prev",
								},
								breakpoints: {
									991: {
										slidesPerView: 3,
										spaceBetween: 24,
									},
									767: {
										slidesPerView: 2.3,
										spaceBetween: 16,
									},
									575: {
										slidesPerView: 1.3,
										spaceBetween: 16,
									},
								},
							});
						});
					})
				} else {
					console.log( result.msg )
				}

			})

		},


		getUsePopupList () {

			this.popupList = []

			const self = this
			self.axiosCaller.get( self, self.APIs.DISPLAY_POPUP + "/getUsePopupList", {}, (res) => {

				const result = res.data

				if ( result.status === "ok" ) {

					self.popupList = result.popupList
					this.$nextTick(() => {
						self.openPopup()
					})
				} else {
					console.log( result.msg )
				}

			})

		},


		openPopup () {

			const self = this

			let top = 0;
			let left = 0;
			self.popupList.forEach(list => {
				var cName = 'popup_' + list.idx;

				if(self.getCookie(cName) === null){
					this.$nextTick(() => {

						const url = self.APIs.BASE_URL + "/popup/" + list.idx + "?isLayout=false";
						const target = "new" + list.idx;
						const options = "width=" + list.sizeX + ",height=" + list.sizeY + ",top=" + top + ",left=" + left;
						this.appOpen({
							url: url,
							target: target,
							options: options,
						})

						if ( window.screenLeft >= 0 ) {
							left += list.sizeX
						} else {
							left -= list.sizeX * 2
						}
					})
				}

			});

		},


		recentBoardList () {

			this.boardList = []

			const self = this
			self.axiosCaller.get( self, self.APIs.DISPLAY + "/main/recentBoardList", {
				boardKeys: 'news_feeds,trend_events,success_examples,sw_examples,consulting_services,guide_function,site_notice',
				page: 0,
				size: 8,
				sort: 'createDate,DESC',
				isLogin: this.isLogin(),
				isUse: true
			}, (res) => {

				const result = res.data
				console.log("recentBoardList")
				console.log(result)

				if ( result.status === "ok" ) {

					self.boardList = result.list

				} else {
					console.log( result.msg )
				}

			})

		},




		goBoardView( _boardKey, _bidx ) {
			this.webUtils.goTo(this, '/app/board/' + _boardKey + '/?idx=' + _bidx)
		},


		goLearning(_emIdx) {
			this.webUtils.goTo(this, '/app/education/main/?mode=learn&emIdx=' + _emIdx)
		},



	},
}
</script>

<style scoped>

</style>
